export function takePhoto(callback) {
    const pictureOptions = {
        cameraDirection: Camera.Direction.BACK,
        saveToPhotoAlbum: true,
        destinationType: Camera.DestinationType.DATA_URL,
        quality: 80,
        correctOrientation: true,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPG,
        mediaType: Camera.MediaType.PICTURE,
    };
    navigator.camera.getPicture(
        image => {
            callback(image);
        },
        () => {},
        pictureOptions
    );
}

export function selectPhoto(callback) {
    const pictureOptions = {
        cameraDirection: Camera.Direction.BACK,
        saveToPhotoAlbum: true,
        destinationType: Camera.DestinationType.DATA_URL,
        quality: 80,
        sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
        correctOrientation: true,
        encodingType: Camera.EncodingType.JPG,
        mediaType: Camera.MediaType.PICTURE,
    };
    navigator.camera.getPicture(
        image => {
            callback(image);
        },
        () => {},
        pictureOptions
    );
}